import jwt_decode from 'jwt-decode';
import { transformChats, getAuthors, setUserName } from "../../helpers/content";
import router from '../../router';

const host = process.env.VUE_APP_API_URI;

// initial state
const state = {
  device_id: Math.random()
    .toString(36)
    .substr(2, 9),
  userName: null,
  loaderPosition: "left",
  showChapterView: "",
  additionalScript: false,
  chapterType: "",
  all: [],
  authors: {},
  mode: null,
  uInfo: null,
  token: null,
  trainingId: null,
  preloader: false,
  chatLang: 'no',
  allChatLangs: []
};

// getters
const getters = {
  getDeviceId: (state) => () => {
    return state.device_id;
  },
  getAllChats: (state) => () => {
    return state.all;
  },
  getAllActiveChats: (state) => () => {
    const allChats = state.all;
    const activeChats = allChats.filter((el) => el.active == true);
    activeChats.sort((a, b) => (a.lastUpdated < b.lastUpdated ? 1 : -1));
    return activeChats;
  },
  getChatById: (state, getters) => (id) => {
    const mode = getters.getMode;
    return state.all.find((user) => {
      return mode && mode === 'preview' && user.chatgroupId == id || user.id == id;
    });
  },
  getChatByName: (state) => (name) => state.all.find((user) => user.name === name),
  getChatPageUrl: () => (id) => {
    return `/chat/${id}`;
  },
  getChatProfilePageUrl: () => (id) => {
    return `/chat/${id}/profile`;
  },
  getChatAuthorByName: (state) => (name) => state.authors[name],
  getProcessingValue: (state, getters) => (id) => {
    const chat = getters.getChatById(id);
    return chat.isProcessing;
  },
  getChapterViewValue: (state) => () => {
    return state.showChapterView;
  },
  getFormattedChatName: () => (chatName) => {
    const names = chatName.split(", ");
    let formattedChatName = "";
    if (names.length > 1) {
      const displayNames = 3;
      const othersAmount = names.length - displayNames - 1; // -1 is for yourself
      for (let i = 0; i < displayNames; i++) {
        const name = names[i].split(" ")[0];
        formattedChatName +=
          i + 1 == displayNames && othersAmount > 0
            ? `${name}... +${othersAmount}`
            : `${name}, `;
      }
      if (othersAmount <= 0) {
        // remove last comma
        formattedChatName = formattedChatName.substr(
          0,
          formattedChatName.length - 2
        );
      }
    } else {
      formattedChatName = names[0];
    }
    return formattedChatName;
  },
  getChatLastMessage: (state, getters) => (id) => {
    const chat = getters.getChatById(id);
    if (chat.messages) {
      const lastMessageIndex = chat.messages.length - 1;
      return chat.messages[lastMessageIndex];
    }
    // if(chat.messages.length > 0) {
    //   const lastMessageIndex = chat.messages.length - 1;
    //   return chat.messages[lastMessageIndex];
    // }
  },
  getLoaderPosition: (state) => () => {
    return state.loaderPosition;
  },
  getAnswer: (state, getters) => (id) => {
    const chat = getters.getChatById(id);
    return chat && chat.answer;
  },
  getMessageLoadingValue: (state, getters) => (id) => {
    const chat = getters.getChatById(id);
    return chat && chat.messageLoading;
  },
  getChapterType: (state) => {
    return state.chapterType;
  },
  getMode: (state) => {
    return state.mode;
  },
  getUInfo: (state) => {
    return state.uInfo;
  },
  getTrainingId: (state) => {
    return state.trainingId;
  },
  getToken: (state) => {
    return state.token;
  },
  getPreloaderStatus: (state) => {
    return state.preloader;
  },
  getChatLanguage: (state) => {
    return state.chatLang;
  },
  getAllChatLanguages: (state) => {
    return state.allChatLangs;
  }
};

// actions
const actions = {
  videoWatched: ({ commit, getters }, params) => {
    const uInfo = getters.getUInfo;
    const token = getters.getToken;

    commit("VIDEO_WATCHED", {
      showNotification: params.showNotification,
      chat: params.chat,
      uInfo,
      token,
    });
  },
  setNewChatData: ({ commit, getters }, params) => {
    commit("SET_NEW_CHAT_DATA", {
      chat: getters.getChatById(params.chatId),
      notification: params.notification,
      messages: params.messages,
      script: params.script,
    });
  },
  insertNewChatData: ({ commit, getters }, params) => {
    const chat = getters.getChatById(params.chatId);
    commit("INSERT_NEW_CHAT_DATA", {
      import: params.import,
      chat: chat,
    });
  },
  // resetNewData: ({ commit, getters }, params) => {
  //   const chat = getters.getChatById(params.chatId);

  //   commit("RESET_NEW_DATA", {
  //     chat: chat,
  //   });
  // },
  // importNewData: ({ commit, getters }, params) => {
  //   const chat = getters.getChatById(params.chatId);

  //   commit("IMPORT_NEW_DATA", {
  //     chat: chat,
  //     importedData: params.data
  //   });
  // },
  // insertNewChatData: ({ commit, getters }, params) => {
  //   const chat = getters.getChatById(params.chatId);

  //   commit("INSERT_NEW_CHAT_DATA", {
  //     chat: chat,
  //     notification: params.notification,
  //     messages: params.messages,
  //     script: params.script
  //   });
  // },
  toggleProcessing: ({ commit }, params) => {
    commit("TOGGLE_PROCESSING", {
      chat: params.chat,
      value: params.value,
    });
  },
  hideNotificationMessage: ({ commit }, params) => {
    commit("HIDE_NOTIFICATION_MESSAGE", {
      chatId: params.chatId,
    });
  },
  makeChatActive: ({ commit, getters }, params) => {
    const chat = getters.getChatById(params.chatId);
    commit("MAKE_CHAT_ACTIVE", {
      chat: chat,
    });
    commit("UPDATE_LAST_UPDATE_TIME", {
      chat: chat,
      time: Date.now(),
    });
  },
  insertAnswer: ({ commit, getters }, params) => {
    const chat = getters.getChatById(params.chatId);
    const uInfo = getters.getUInfo;
    const additionalScript = params.additionalScript;
    const token = getters.getToken;

    commit("REMOVE_ITEM_FROM_SCRIPT", {
      chat: chat,
    });

    commit("INSERT_ANSWER", {
      chat: chat,
      value: params.value,
      type: params.type,
      phone: params.phone_number,
      device_id: params.device_id,
      answerKey: params.answerKey,
      parentId: params.parentId,
    });

    if (token) {
      const body = JSON.stringify({
        lastMessageId: params.answerKey,
        answerParentId: params.parentId,
        isKeyQuestion: params.saveAnswer,
      });

      fetch(`${host}/api/update-progress`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-U-Info": uInfo
        },
        method: "PATCH",
        body,
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText);
          return response.json();
        })
        .catch((error) => {
          console.log("request failed", error);
          router.push('/register');
        });
    }

    if (Object.keys(additionalScript).length) {
      commit("ADD_ADDITIONAL_SCRIPT", {
        chat: chat,
        script: additionalScript,
      });
    }
  },
  insertMessage: ({ commit, getters }, params) => {
    const objData = params.object;
    const uInfo = getters.getUInfo;
    const token = getters.getToken;

    if (objData.type != "chapter-end" && objData.type != "chapter-end-same-chat") {
      commit("INSERT_MESSAGE", {
        uInfo,
        token,
        showNotification: params.showNotification,
        chat: params.chat,
        objectData: {
          key: objData.key,
          type: objData.type,
          author: objData.author,
          content_type: objData.content_type,
          value: objData.value,
          time: Date.now(),
        },
      });
      commit("UPDATE_LAST_UPDATE_TIME", {
        chat: params.chat,
        time: Date.now(),
      });
    } else {
      setTimeout(() => {
        commit("SHOW_CHAPTER_VIEW", {
          value: objData.value,
          type: objData.type
        });
      }, 3000);
    }
  },
  showAnswer: ({ commit }, params) => {
    commit("SHOW_ANSWER", {
      chat: params.chat,
      answer: params.value,
    });
  },
  showMessageLoader: ({ commit }, params) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit("SHOW_MESSAGE_LOADER", {
          chat: params.chat,
        });
        resolve();
      }, params.delay);
    });
  },
  hideMessageLoader: ({ commit }, params) => {
    commit("HIDE_MESSAGE_LOADER", {
      chat: params.chat,
    });
  },
  toggleMessageType: async ({ commit }, params) => {
    commit("TOGGLE_MESSAGE_TYPE", {
      message: params.message,
    });
  },
  removeItemFromScript: ({ commit }, params) => {
    commit("REMOVE_ITEM_FROM_SCRIPT", {
      showNotification: params.showNotification,
      chat: params.chat,
    });
  },
  hideChapterView: ({ commit, getters }, params) => {
    const chat = getters.getChatById(params.chatId);
    commit("HIDE_CHAPTER_VIEW", {
      chat: chat,
      type: getters.getChapterType,
    });
  },
  loadChats: ({ dispatch, commit, getters }, params) => {
    const id = params.url.params.phone_number;
    const language = params.url.params.language;
    const mode = getters.getMode;
    const uInfo = getters.getUInfo;
    const token = getters.getToken;
    let url;

    dispatch('showPreloader');

    if (token && id) {
      url = `${host}/api/training-content`;

      commit('SET_USER_NAME', {
        token,
      });
    }

    if (mode === 'preview') {
      const { id } = params.url.params;
      localStorage.removeItem('store');
      if (id) {
        url = `${host}/api/content/chat/${id}/preview?language=${language}`
      }
    }

    if (url && ((token && id) || mode === 'preview')) {
      fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-U-Info": uInfo
        },
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText);
          return response.json();
        })
        .then((data) => {
          const chats = transformChats(data);
          commit("SET_CHATS", {
            chats,
          });

          const authors = getAuthors(data);
          commit('SET_AUTHORS', {
            authors,
          });

          commit('SET_CHAT_LANGUAGE', {
            chatLang: data.contentLanguage,
          });
          
          dispatch('hidePreloader');
        })
        .catch((error) => {
          console.error("request failed", error);
          router.push('/redirect');
        });
    }
  },
  setMode({ commit }, params) {
    const { mode } = params;
    commit('SET_MODE', {
      mode,
    });
  },
  setUInfo({ commit }, params) {
    const { uInfo } = params;
    commit('SET_U_INFO', {
      uInfo,
    });
  },
  setToken({ commit }, params) {
    const { token } = params;
    commit('SET_TOKEN', {
      token,
    });
  },
  setTrainingId({ commit }, params) {
    const { trainingId } = params;
    commit('SET_TRAINING_ID', {
      trainingId,
    });
  },
  togglePreloader({ commit, getters }) {
    commit('TOGGLE_PRELOADER', {
      preloader: !getters.getPreloaderStatus,
    });
  },
  showPreloader({ commit }) {
    commit('SHOW_PRELOADER');
  },
  hidePreloader({ commit }) {
    commit('HIDE_PRELOADER');
  },
  clearChats({ commit }) {
    commit('SET_CHATS', {
      chats: []
    });
  },
  setChatLanguage({ dispatch, getters }) {
    const token = getters.getToken;
    const chatLang = getters.getChatLanguage;

    dispatch('showPreloader');

    fetch(`${host}/api/update-language`, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        "language": chatLang,
      })
    })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then(() => {
        location.reload(true);
      })
      .catch((error) => {
        console.error("request failed", error);
        router.push('/redirect');
      });
  },
  loadAllChatLanguages: ({ dispatch, commit }, params) => {
    const url = `${host}/api/languages`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        commit("SET_ALL_CHAT_LANGUAGES", {
          allChatLangs: data,
        });
        dispatch('loadChats', params);
      })
      .catch((error) => {
        console.error("request failed", error);
        router.push('/redirect');
      });
  },
  setAllChatLanguages({ commit }, params) {
    const { allChatLangs } = params;
    commit('SET_ALL_CHAT_LANGUAGES', {
      allChatLangs,
    });
  }
};

// mutations
const mutations = {
  VIDEO_WATCHED(state, payload) {
    const chat = payload.chat;
    const messagesAmount = chat.messages.length;
    const showNotification = payload.showNotification;
    const messages = chat.messages;

    chat.notificationShow = showNotification;

    if (messagesAmount > 0) {
      const { key } = messages[messagesAmount - 1];
      const uInfo = payload.uInfo;
      const token = payload.token;
      const body = JSON.stringify({
        lastMessageId: key,
      });
      messages[messagesAmount - 1].wasPlayedEarlier = true;

      if (token) {
        fetch(`${host}/api/update-progress`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-U-Info": uInfo,
          },
          method: "PATCH",
          body,
        })
          .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
          })
          .catch((error) => {
            console.log("request failed", error);
            router.push('/register');
          });
      }
      
    }
  },
  SET_NEW_CHAT_DATA(state, payload) {
    state.additionalScript = {
      notification: payload.notification,
      messages: payload.messages,
      script: payload.script,
    };
  },
  INSERT_NEW_CHAT_DATA(state, payload) {
    const additionalScript = state.additionalScript;
    const chat = payload.chat;

    if (payload.import) {
      chat.newData = payload.import;
    } else {
      chat.newData = false;
    }

    if (additionalScript) {

      if (additionalScript.messages) {
        additionalScript.messages.forEach((el) => {
          chat.messages.push(el);
        });
      }

      if (additionalScript.script) {
        additionalScript.script.forEach((el) => {
          chat.script.push(el);
        });
      }

      chat.notification = additionalScript.notification;
      chat.isProcessing = false;

      // if (additionalScript.script.length == 0) {
      //   chat.notificationShow = true;
      // }
    }

    if (chat.script.length == 0) {
      chat.notificationShow = true;
    }
  },
  SHOW_CHAPTER_VIEW(state, payload) {
    state.showChapterView = payload.value;
    state.chapterType = payload.type;
  },
  HIDE_CHAPTER_VIEW(state, payload) {
    const chat = payload.chat;
    state.showChapterView = "";

    if (payload.type == 'chapter-end-same-chat') {
      chat.isProcessing = false;
      chat.notificationShow = false;
      chat.notification = chat.newData.notification;
      chat.script = chat.newData.script;
      chat.newData = chat.newData.import;
      Event.fire('script-loaded');
    } else {
      chat.notificationShow = true;
    }

  },
  TOGGLE_PROCESSING(state, payload) {
    const chat = payload.chat;
    chat.isProcessing = payload.value;
  },
  ADD_ADDITIONAL_SCRIPT(state, payload) {
    const chat = payload.chat;
    const script = payload.script.reverse();

    script.forEach((el) => {
      chat.script.unshift(el);
    });
  },
  HIDE_NOTIFICATION_MESSAGE(state, payload) {
    const chat = state.all.find((el) => el.id == payload.chatId);
    chat.notificationShow = false;
  },
  MAKE_CHAT_ACTIVE(state, payload) {
    const chat = payload.chat;
    chat.active = true;
  },
  TOGGLE_MESSAGE_TYPE(state, payload) {
    state.loaderPosition = !payload.message.author ? "right" : "left";
  },
  SHOW_ANSWER(state, payload) {
    if (payload.answer) {
      payload.chat.answer = payload.answer;
    }
  },
  UPDATE_LAST_UPDATE_TIME(state, payload) {
    const chat = payload.chat;
    const time = payload.time;

    chat.lastUpdated = time;
  },
  INSERT_MESSAGE(state, payload) {
    const chat = payload.chat;
    const data = payload.objectData;
    const uInfo = payload.uInfo;
    const token = payload.token;

    if (token && data.content_type !== 'video') {
      const body = JSON.stringify({
        lastMessageId: data.key,
      });

      fetch(`${host}/api/update-progress`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-U-Info": uInfo,
        },
        method: "PATCH",
        body,
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText);
          return response.json();
        })
        .catch((error) => {
          console.log("request failed", error);
          router.push('/register');
        });
    }

    chat.messages.push({
      type: data.type,
      author: data.author,
      key: data.key,
      content_type: data.content_type,
      value: data.value,
      time: data.time,
    });

    // show chat notification
    if (chat.script.length == 0) {
      if (chat.notification.nextChatId && payload.showNotification) {
        chat.notificationShow = true;
      }
    }
  },
  INSERT_ANSWER(state, payload) {
    // const device_id = payload.device_id;
    let value = payload.value;
    const chat = payload.chat;

    const answerSchema = {
      type: "message",
      author: 0,
      content_type: payload.type,
      value: value,
      time: new Date(),
      key: payload.answerKey
    };
    chat.messages.push(answerSchema);
    chat.answer = "";

    // showing chat notification
    if (chat.script.length == 0) {
      if (chat.notification.nextChatId) {
        chat.notificationShow = true;
      }
    }
  },
  REMOVE_ITEM_FROM_SCRIPT(state, payload) {
    const chat = payload.chat;
    chat.script.shift();
  },
  SHOW_MESSAGE_LOADER(state, payload) {
    const chat = payload.chat;
    chat.messageLoading = true;
  },
  HIDE_MESSAGE_LOADER(state, payload) {
    const chat = payload.chat;
    chat.messageLoading = false;
  },
  SET_CHATS(state, payload) {
    state.all = payload.chats;
  },
  SET_AUTHORS(state, payload) {
    state.authors = payload.authors;
  },
  SET_USER_NAME(state, payload) {
    const { token } = payload;
    let fullName = jwt_decode(token).name;
    let name = null;

    if (fullName && typeof fullName === 'string') {
      fullName = fullName.trim();

      if (fullName.length > 0) {
        const brakePosition = fullName.indexOf(' ');

        name = (brakePosition === -1)
          ? fullName
          : fullName.substring(0, brakePosition);

        setUserName(name);
      }
    }

    state.userName = name;
  },
  SET_MODE(state, payload) {
    const { mode } = payload;
    state.mode = mode;
  },
  SET_U_INFO(state, payload) {
    const { uInfo } = payload;
    state.uInfo = uInfo;
  },
  SET_TRAINING_ID(state, payload) {
    const { trainingId } = payload;
    state.trainingId = trainingId;
  },
  SET_TOKEN(state, payload) {
    const { token } = payload;
    state.token = token;
  },
  TOGGLE_PRELOADER(state, payload) {
    const { preloader } = payload;
    state.preloader = preloader;
  },
  SHOW_PRELOADER(state) {
    state.preloader = true;
  },
  HIDE_PRELOADER(state) {
    state.preloader = false;
  },
  SET_CHAT_LANGUAGE(state, payload) {
    const { chatLang } = payload;
    state.chatLang = chatLang;
  },
  SET_ALL_CHAT_LANGUAGES(state, payload) {
    const { allChatLangs } = payload;
    state.allChatLangs = allChatLangs;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
